module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('b-btn', {
    on: {
      "click": _vm.openTargetChangeModal
    }
  }, [_vm._v(_vm._s(_vm.$t(("campaign_field.title.target_change_view." + _vm.target_change_status))))]), _c('b-modal', {
    ref: "modal",
    staticClass: "target-change-modal",
    attrs: {
      "size": "md",
      "title": _vm.$t(("pos.campaign.target-change-modal.title." + _vm.target_change_status)),
      "fade": false
    }
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('div', {
    staticClass: "row mt-1"
  }, _vm._l((_vm.changedTargetFields), function(field) {
    return _c('div', {
      staticClass: "col-md-6 col-sm-6 mt-2"
    }, [_c('h2', {
      staticClass: "box-widget-list-header"
    }, [_vm._v(_vm._s(field.name))]), _c('span', {
      staticClass: "box-widget-list-value"
    }, [_vm._v(_vm._s(_vm.isEmpty(field.value)) + "     ")])])
  }))]), _c('template', {
    slot: "modal-footer"
  }, [_c('gotu-nav-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('terms.misc.cancel')) + " ")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51aa66a7"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/campaign-target-popup/CampaignTargetPopup.vue
// module id = 2042
// module chunks = 1